var render = function render(){var _vm=this,_c=_vm._self._c;return _c('store-selection',{staticClass:"store-locator-standalone",attrs:{"event-only":true,"hard-load":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }